




















import Vue from "vue";
import router from "@/router";

export default Vue.extend({
  name: "CalendarLayoutSelectors",
  methods: {
    setLayout(param: any) {
      if (param) {
        router
          .push({
            query: { view: param, related: this.$route.query.related }
          })
          .catch(e => {});
      }
    }
  }
});
